module.exports = __webpack_public_path__ + "img/order_coin.3b44e120.png";